<template>
<div class="history-content">
	<div class="van-nav-bar van-hairline--bottom custom-nav-bar">
		<div class="van-nav-bar__content">
			<div class="van-nav-bar__left van-haptics-feedback" @click="back()">
				<i class="van-badge__wrapper van-icon van-icon-arrow-left van-nav-bar__arrow"></i>
			</div>
			<div class="van-nav-bar__title van-ellipsis">
				{{$t('game.workRecord')}}
			</div>
		</div>
	</div>
	<van-tabs color="#667eea" title-active-color="#667eea" :before-change="beforeChange" title-inactive-color="#667eea" animated>
	  <van-tab :title="v.name" class="det" v-for="(v,key) in navList" :key="key">
		  <div class="history">
			  <van-pull-refresh v-model="isLoading" class="fixedStyle"  @refresh="onRefresh">
			    <van-list
					v-model="loading"
					:finished="finished"
					:immediate-check="false"
					@load="onLoad"
			        :finished-text="$t('common.nomore')"
			        >
			  	  <div class="list-container">
					  <van-cell-group class="custom-cell-group">
			  	    <van-cell v-for="(item,i) in list" :key="i" class="custom-cell" @click="toDetail(item)" >
			  			<template #title>
			  				<div class="cell-content">
								<div class="icon-box">
									<span class="icon">$</span>
								</div>
								<div class="info">
									<span class="game-name">{{item.name}}</span>
									<span class="game-types">
										{{$t('orderContentLabel')}}
									<span v-for="(datai,ss) in item.data" :key="ss">{{getGameTypeLabel(datai.type)}} </span>
									<span v-if="!item.data.length">{{item.status_text || $t('waitingResultLabel')}}</span>
								</span>
								</div>
			  				</div>
			  			</template>
						<template #default>
							<div class="right-content">
								<span class="period-info">
									{{item.create_time || ($t('game.day') + item.expect + $t('game.period'))}}
								</span>
								<span class="amount">{{item.money}} Points</span>
							</div>
						</template>
			  		</van-cell>
			  	  </van-cell-group>
				  </div>
			    </van-list>
			    <van-empty :description="$t('common.nodata')" v-if="list.length === 0"/>
			  </van-pull-refresh>
		  </div>
	  </van-tab>
	</van-tabs>
	<van-popup v-model="showRight" position="right" class="his" :style="{ width: '80%' ,height: '100%'}" >
		<p>{{$t('game.allWork')}}</p>
		<ul>
			<li @click="changeLottery(v.id)" v-for="(v,key) in game_type_list" :key="key" :class="v.id==lottery_id?'active':''">
				{{v.name}}
			</li>
		</ul>
		<div class="btn">
			<p @click="lottery_id='all'">{{$t('game.reset')}}</p>
			<p @click="showRight=false">{{$t('game.confirm')}}</p>
		</div>
	</van-popup>
</div>
</template>

<script>
import { Toast } from 'vant';
export default {
  data() {
    return {
		showRight:false,
		lottery_id:'all',
		game_type_list: [],
		status:0,
		page:1,
		isLoading: false,
		count:0,
		limit:10,
		loading: false,
		finished: false,
		refreshing: false,
		tableList:[],
		list:[],
		navList:[{name:this.$t('all'),value:0},{name:this.$t('bonusPointsLabel'),value:1},{name:this.$t('waitingResultLabel'),value:2},{name:this.$t('missionMoneyDetails'),value:3}],
    };
  },
  mounted () {
    window.addEventListener("scroll", this.scrollTops, true);
  },
  
  beforeDestroy() {
    window.removeEventListener("scroll", this.scrollTops, true);
  },
  methods: {
    getGameTypeLabel(type) {
      const rawType = String(type || '').trim();
      const normalizedType = rawType.toUpperCase();
      const labels = {
        BESAR: this.$t('betOptions.rose') + ' 🌹',
        KECIL: this.$t('betOptions.lily') + ' ⚜️',
        GENAP: this.$t('betOptions.fireworks') + ' 🎆',
        GANJIL: this.$t('betOptions.balloon') + ' 🎈',
        '大': this.$t('betOptions.rose') + ' 🌹',
        '小': this.$t('betOptions.lily') + ' ⚜️',
        '双': this.$t('betOptions.fireworks') + ' 🎆',
        '單': this.$t('betOptions.balloon') + ' 🎈',
        '单': this.$t('betOptions.balloon') + ' 🎈'
      };
      return labels[normalizedType] || labels[rawType] || rawType;
    },
    back(){
      this.$router.push({path:'Mine'})
    },
	getGameItem(){
	  this.$http({
	    method: 'get',
	    url: 'lottery_hot'
	  }).then(res=>{
	    this.game_type_list = res.data
	  })
	},
	toDetail(item){
	  sessionStorage.setItem('currentGameRecord', JSON.stringify(item));
	  const firstDetail = Array.isArray(item.data) && item.data.length ? item.data[0] : {};
	  this.$router.push({path:'/GameDetail', query:{
		expect:item.expect,
		lid:item.lottery_id || item.lid || firstDetail.lid || '',
		name:item.name,
		money:item.money,
		time:item.create_time,
		status:item.status
	  }})
	},
	beforeChange(index) {
	  this.status = index;
	  this.resetAndLoad()
	  return true;
	},
	longPress() {
	  const scrollContainer = document.querySelector('.fixedStyle');
	  if (scrollContainer) scrollContainer.scrollTop = 0;
	},
	scrollTops(){
	  const scrollContainer = document.querySelector('.fixedStyle');
	  if (scrollContainer) this.scrollTop1 = scrollContainer.scrollTop;
	},
    onRefresh(){
      this.resetAndLoad(true);
    },
	changeLottery(id){
		this.lottery_id = id;
		this.resetAndLoad();
	},
    normalizeRecord(item) {
      const lottery = item.lottery || {};
      return {
        ...item,
        lottery_id: item.lottery_id || item.lid || lottery.id || (Array.isArray(item.data) && item.data[0] ? item.data[0].lid : '') || '',
        name: item.name || item.lottery_name || lottery.name || this.$t('game.workRecord'),
        expect: item.expect || item.issue || item.period || '--',
        money: item.money !== undefined ? item.money : (item.amount !== undefined ? item.amount : '0.00'),
        create_time: item.create_time || item.created_at || '',
        data: Array.isArray(item.data) ? item.data : (Array.isArray(item.details) ? item.details : [])
      };
    },
    resetAndLoad(showToast = false) {
      this.page = 1;
      this.list = [];
      this.finished = false;
      this.loading = true;
      return this.getUserGameList(false).finally(() => {
        this.isLoading = false;
        if (showToast) Toast(this.$t('common.refresh'));
      });
    },
    getUserGameList(append = false){
      return this.$http({
        method: 'get',
		data:{page: this.page,pageSize: this.limit,limit: this.limit,status:this.status,lottery_id:this.lottery_id},
        url: 'user_get_game_list'
      }).then(res=>{
        if(res.code === 200){
		  const payload = res.data || {};
		  let rows = Array.isArray(payload) ? payload : (payload.list || payload.data || []);
		  if (!Array.isArray(rows) && rows && typeof rows === 'object') rows = Object.values(rows);
		  rows = rows.map(this.normalizeRecord);
		  this.list = append ? this.list.concat(rows) : rows;
		  const pagination = payload.pagination || {};
		  const totalPages = Number(pagination.totalPages || pagination.last_page || 0);
		  const total = Number(pagination.total || payload.total || 0);
		  this.finished = totalPages ? this.page >= totalPages : (total ? this.list.length >= total : rows.length < this.limit);
		  if (!this.finished) this.page += 1;
        }else if(res.code ===401){
          this.$toast(res.msg);
        }
	  }).catch(() => {
		this.finished = true;
	  }).finally(() => {
		this.loading = false;
		this.isLoading = false;
	  })
    },
	onLoad() {
	  if (!this.finished) this.getUserGameList(this.page > 1)
	},
  },
  created() {
    if(!localStorage.getItem('token')){
      this.$router.push({path:'/Login'})
    }else {
	  this.resetAndLoad();
	  this.getGameItem();
    }
  }
};
</script>

<style lang='less' scoped>
@import "../../assets/css/base.css";

:export {
    gbcolor: linear-gradient(135deg, #3498db, #8e44ad)
}

.history-content {
    width: 100%;
    min-height: 100vh;
    background: white;
}

/* 顶部导航栏样式 - 填充渐变色 */
.custom-nav-bar {
    height: 3.5rem;
    line-height: 3.5rem;
    background: linear-gradient(135deg, #3498db 0%, #8e44ad 100%);
    position: relative;
    z-index: 10;
}

.custom-nav-bar::after {
    display: none;
}

.van-nav-bar__title {
    max-width: 60%;
    margin: 0 auto;
    color: white !important;
    font-weight: 600;
    font-size: 1.1rem;
}

.van-nav-bar__left,
.van-nav-bar__right {
    padding: 0 15px;
}

.van-nav-bar__arrow,
.van-nav-bar__right .van-icon {
    color: white !important;
    font-size: 1.2rem;
}

/* 标签页样式 */
.van-tabs {
    background: white;
}

::v-deep .van-tabs__wrap {
    background: white;
    border-bottom: 1px solid #f0f0f0;
}

::v-deep .van-tab {
    font-size: 0.9rem;
}

/* 内容区域 */
.history {
    background: white;
}

.fixedStyle {
    background: white;
    min-height: calc(100vh - 8rem);
}

.list-container {
    padding: 1rem;
}

/* 自定义单元格组 */
.custom-cell-group {
    background: transparent;
    border: none;
}

.custom-cell-group::after,
.custom-cell-group::before {
    display: none;
}

/* 每个栏目带边框 */
.custom-cell {
    margin-bottom: 0.8rem;
    border: 1.5px solid #e8e8e8;
    border-radius: 12px;
    padding: 1rem;
    background: white;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
    transition: all 0.3s ease;
    cursor: pointer;
}

.custom-cell:active {
    background-color: #f8f9ff;
    border-color: #667eea;
    transform: translateY(1px);
}

.custom-cell::after {
    display: none;
}

/* 单元格内容布局 */
.cell-content {
    display: flex;
    align-items: center;
    gap: 0.8rem;
}

.icon-box {
    width: 3rem;
    height: 3rem;
    background: linear-gradient(135deg, #3498db, #8e44ad);
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-shrink: 0;
}

.icon {
    color: white;
    font-size: 1.2rem;
    font-weight: bold;
}

.info {
    flex: 1;
    display: flex;
    flex-direction: column;
    gap: 0.3rem;
}

.game-name {
    font-size: 1rem;
    font-weight: 600;
    color: #333;
}

.game-types {
    font-size: 0.85rem;
    color: #666;
}

/* 右侧内容 */
.right-content {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    gap: 0.3rem;
}

.period-info {
    font-size: 0.8rem;
    color: #b2a8cd;
}

.amount {
    font-size: 1rem;
    font-weight: 600;
    color: #36c989;
}

/* 侧边栏样式 */
.his {
    width: 80%;
    height: 100%;
    padding: 5%;
    background: white;
}

.his p {
    text-align: left;
    font-size: 1rem;
    color: #4c368c;
    font-weight: 600;
    margin-bottom: 1rem;
}

.his ul {
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-start;
    align-items: center;
    padding-top: 1rem;
}

.his ul li {
    width: 40%;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #667eea;
    border: 1.5px solid #667eea;
    border-radius: 8px;
    margin-right: 0.5rem;
    margin-bottom: 0.5rem;
    padding: 0.5rem 0;
    font-size: 0.9rem;
    transition: all 0.3s ease;
}

.his ul li.active {
    color: white;
    border: none;
    background: linear-gradient(135deg, #3498db, #8e44ad);
}

.his .btn {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    margin: auto;
    padding: 5%;
}

.his .btn p {
    color: #667eea;
    border: 1.5px solid #667eea;
    border-radius: 25px;
    padding: 0.5rem 1.5rem;
    font-size: 0.9rem;
    transition: all 0.3s ease;
}

.his .btn p:last-child {
    color: white;
    border: none;
    background: #667eea;
}

.his .btn p:active {
    transform: scale(0.95);
}

/* 空状态样式 */
.van-empty {
    padding: 3rem 1rem;
}

::v-deep .van-empty__description {
    color: #969799;
    font-size: 0.9rem;
}

/* 动画效果 */
@keyframes fadeInUp {
    from { 
        opacity: 0; 
        transform: translateY(15px); 
    }
    to { 
        opacity: 1; 
        transform: translateY(0); 
    }
}

.custom-cell {
    animation: fadeInUp 0.4s ease forwards;
}

.custom-cell:nth-child(odd) {
    animation-delay: 0.1s;
}

.custom-cell:nth-child(even) {
    animation-delay: 0.2s;
}

/* 响应式调整 */
@media (max-width: 320px) {
    .list-container {
        padding: 0.8rem;
    }
    
    .custom-cell {
        padding: 0.8rem;
        margin-bottom: 0.6rem;
    }
    
    .icon-box {
        width: 2.5rem;
        height: 2.5rem;
    }
    
    .icon {
        font-size: 1rem;
    }
    
    .game-name {
        font-size: 0.95rem;
    }
    
    .game-types {
        font-size: 0.8rem;
    }
}

/* Date Love Club - task records */
.history-content,
.history,
.fixedStyle {
    background: #030507;
}

.history-content {
    color: #f4dfac;
    background-image: linear-gradient(rgba(2, 4, 7, .91), rgba(2, 4, 7, .97)),
      url('../../assets/img/luxury-dating-bg-v2.png');
    background-position: center top;
    background-size: cover;
    background-attachment: fixed;
}

.custom-nav-bar {
    height: 3.75rem;
    line-height: 3.75rem;
    background: rgba(3, 5, 8, .96);
    border-bottom: 1px solid rgba(222, 183, 104, .45);
}

.van-nav-bar__title,
.van-nav-bar__arrow,
.van-nav-bar__right .van-icon {
    color: #f3d47f !important;
}

.van-nav-bar__title {
    font-size: 1.35rem;
    font-weight: 800;
}

::v-deep .van-tabs__wrap,
::v-deep .van-tabs__nav {
    height: 3.65rem;
    background: rgba(5, 8, 12, .98);
}

::v-deep .van-tab {
    padding: 0 .7rem;
    color: #d8c6a3 !important;
    font-size: 1.02rem;
    white-space: nowrap;
}

::v-deep .van-tab--active {
    color: #f1cd71 !important;
    font-weight: 700;
}

::v-deep .van-tabs__line {
    width: 2.2rem;
    height: .2rem;
    border-radius: 1rem;
    background: linear-gradient(90deg, #b77b2e, #f3d47f) !important;
}

.fixedStyle {
    min-height: calc(100vh - 7.4rem);
}

.list-container {
    padding: 1rem .8rem 2rem;
}

.custom-cell {
    min-height: 6.8rem;
    margin-bottom: .9rem;
    padding: 1rem;
    border: 1px solid rgba(222, 183, 104, .4);
    border-radius: 1rem;
    background: linear-gradient(145deg, rgba(17, 20, 25, .98), rgba(7, 10, 14, .98));
    box-shadow: 0 .7rem 1.5rem rgba(0, 0, 0, .28);
}

.custom-cell:active {
    border-color: #e3bd69;
    background: #111318;
}

.cell-content {
    gap: .9rem;
}

.icon-box {
    width: 3.55rem;
    height: 3.55rem;
    border: 1px solid rgba(250, 223, 162, .75);
    background: linear-gradient(135deg, #a97732, #e7c87c);
    box-shadow: 0 .45rem 1rem rgba(185, 130, 48, .22);
}

.icon {
    color: #171006;
    font-size: 1.3rem;
}

.game-name {
    color: #f1d58f;
    font-size: 1.05rem;
    font-weight: 750;
}

.game-types {
    color: #c9bda9;
    font-size: .9rem;
    line-height: 1.45;
}

.right-content {
    min-width: 7.8rem;
    gap: .55rem;
}

.period-info {
    color: #aaa092;
    font-size: .76rem;
    white-space: normal;
    text-align: right;
}

.amount {
    color: #f0c967;
    font-size: 1rem;
    white-space: nowrap;
}

.his {
    box-sizing: border-box;
    background: #080b10;
    border-left: 1px solid rgba(222, 183, 104, .4);
}

.his p,
.his ul li {
    color: #e6c675;
}

.his ul li {
    border-color: rgba(222, 183, 104, .55);
}

.his ul li.active,
.his .btn p:last-child {
    color: #171006;
    background: linear-gradient(135deg, #b57c30, #e8c66d);
}

::v-deep .van-empty__description,
::v-deep .van-list__finished-text {
    color: #9d9384;
}

@media (max-width: 430px) {
  .history-content {
    width: 100%;
    min-width: 0;
    overflow-x: hidden;
    background-attachment: scroll;
  }

  .custom-nav-bar {
    height: auto;
    min-height: 58px;
    padding-top: env(safe-area-inset-top);
  }

  .custom-nav-bar .van-nav-bar__content {
    min-height: 58px;
  }

  .van-nav-bar__title {
    max-width: calc(100% - 96px);
    font-size: 17px;
    line-height: 1.25;
    white-space: normal;
    overflow-wrap: anywhere;
  }

  ::v-deep .van-tabs__wrap {
    height: 54px;
    overflow-x: hidden;
    overflow-y: hidden;
    -webkit-overflow-scrolling: touch;
    scrollbar-width: none;
  }

  ::v-deep .van-tabs__wrap::-webkit-scrollbar {
    display: none;
  }

  ::v-deep .van-tabs__nav {
    width: 100% !important;
    max-width: 100%;
    min-width: 100%;
    height: 54px;
    box-sizing: border-box;
    padding-right: 0 !important;
    padding-left: 0 !important;
  }

  ::v-deep .van-tab {
    width: 0 !important;
    min-width: 0;
    flex: 1 1 0 !important;
    padding: 0 4px;
    font-size: 13px;
    line-height: 1.25;
    white-space: normal;
  }

  ::v-deep .van-tab__text,
  ::v-deep .van-tab__text--ellipsis {
    max-width: 100%;
    overflow: visible;
    font-size: 12px;
    line-height: 1.2;
    text-overflow: clip;
    white-space: normal;
  }

  .fixedStyle {
    min-height: calc(100svh - 112px);
  }

  .list-container {
    min-width: 0;
    padding: 12px 10px max(22px, env(safe-area-inset-bottom));
  }

  .custom-cell {
    width: 100%;
    min-width: 0;
    min-height: 0;
    display: block;
    padding: 14px 12px;
  }

  .custom-cell ::v-deep .van-cell__title,
  .custom-cell ::v-deep .van-cell__value {
    width: 100%;
    min-width: 0;
    flex: none;
  }

  .custom-cell ::v-deep .van-cell__value {
    margin: 11px 0 0;
    text-align: left;
  }

  .cell-content,
  .info,
  .right-content {
    min-width: 0;
  }

  .cell-content {
    gap: 10px;
  }

  .icon-box {
    width: 44px;
    height: 44px;
    flex: 0 0 44px;
  }

  .game-name,
  .game-types {
    max-width: 100%;
    line-height: 1.4;
    overflow-wrap: anywhere;
  }

  .right-content {
    width: 100%;
    min-width: 0;
    flex-direction: row;
    align-items: flex-start;
    justify-content: space-between;
    gap: 10px;
  }

  .period-info {
    min-width: 0;
    flex: 1;
    text-align: left;
    overflow-wrap: anywhere;
  }

  .amount {
    flex: 0 1 auto;
    max-width: 46%;
    text-align: right;
    white-space: normal;
    overflow-wrap: anywhere;
  }

  .his {
    max-width: calc(100vw - 38px);
    padding: 18px 14px max(20px, env(safe-area-inset-bottom));
    overflow-x: hidden;
    overflow-y: auto;
  }

  .his ul {
    gap: 8px;
  }

  .his ul li {
    width: calc(50% - 4px);
    min-width: 0;
    margin: 0;
    padding: 9px 5px;
    line-height: 1.3;
    overflow-wrap: anywhere;
  }

  .his .btn {
    gap: 8px;
  }

  .his .btn p {
    min-width: 0;
    flex: 1;
    padding: 9px 6px;
    line-height: 1.3;
    text-align: center;
    overflow-wrap: anywhere;
  }
}

@media (max-width: 340px) {
  ::v-deep .van-tab {
    width: 0 !important;
    min-width: 0;
    padding: 0 3px;
    font-size: 12px;
  }

  .list-container {
    padding-right: 8px;
    padding-left: 8px;
  }
}
</style>
